import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BulkEmailService from "services/BulkEmailService";

export const sendBulkEmail = createAsyncThunk(
  "bulkEmails/send",
  async (data, { rejectWithValue }) => {
    try {
      const response = await BulkEmailService.send(data);
      return response.data;
    } catch (error) {
      const err = error.response?.data;
      return rejectWithValue(
        typeof err === "string" ? err : err?.message || err?.error || "Erreur"
      );
    }
  }
);

export const getBulkEmails = createAsyncThunk(
  "bulkEmails/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await BulkEmailService.getAll(params);
      const payload = response.data || {};
      return {
        bulkEmails: payload.data || [],
        totalPages: payload.pages ?? payload.totalPages ?? 1,
        currentPage: payload.page ?? params.page ?? 1,
        totalItems: payload.total ?? payload.totalItems ?? 0,
      };
    } catch (error) {
      const err = error.response?.data;
      return rejectWithValue(
        typeof err === "string" ? err : err?.message || err?.error || "Erreur"
      );
    }
  }
);

export const getBulkEmailById = createAsyncThunk(
  "bulkEmails/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await BulkEmailService.getById(id);
      return response.data.data;
    } catch (error) {
      const err = error.response?.data;
      return rejectWithValue(
        typeof err === "string" ? err : err?.message || err?.error || "Erreur"
      );
    }
  }
);

export const getRecipientsCount = createAsyncThunk(
  "bulkEmails/getRecipientsCount",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await BulkEmailService.getRecipientsCount(params);
      return response.data;
    } catch (error) {
      const err = error.response?.data;
      return rejectWithValue(
        typeof err === "string" ? err : err?.message || err?.error || "Erreur"
      );
    }
  }
);

export const getRecipientsList = createAsyncThunk(
  "bulkEmails/getRecipientsList",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await BulkEmailService.getRecipientsList(params);
      return response.data.data || [];
    } catch (error) {
      const err = error.response?.data;
      return rejectWithValue(
        typeof err === "string" ? err : err?.message || err?.error || "Erreur"
      );
    }
  }
);

export const deleteBulkEmail = createAsyncThunk(
  "bulkEmails/delete",
  async (id, { rejectWithValue }) => {
    try {
      await BulkEmailService.deleteById(id);
      return id;
    } catch (error) {
      const err = error.response?.data;
      return rejectWithValue(
        typeof err === "string" ? err : err?.message || err?.error || "Erreur"
      );
    }
  }
);

const initialState = {
  bulkEmails: [],
  bulkEmail: null,
  recipientsCount: 0,
  recipientsList: [],
  loading: false,
  sending: false,
  error: null,
  totalPages: 1,
  currentPage: 1,
  totalItems: 0,
};

const bulkEmailsSlice = createSlice({
  name: "bulkEmails",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearBulkEmail: (state) => {
      state.bulkEmail = null;
    },
    clearRecipients: (state) => {
      state.recipientsCount = 0;
      state.recipientsList = [];
    },
  },
  extraReducers: {
    // send
    [sendBulkEmail.pending]: (state) => {
      state.sending = true;
      state.error = null;
    },
    [sendBulkEmail.fulfilled]: (state, { payload }) => {
      state.sending = false;
      if (payload?.data) {
        state.bulkEmails = [payload.data, ...state.bulkEmails];
      }
    },
    [sendBulkEmail.rejected]: (state, { payload }) => {
      state.sending = false;
      state.error = payload;
    },

    // getAll
    [getBulkEmails.pending]: (state) => {
      state.loading = true;
    },
    [getBulkEmails.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.bulkEmails = payload.bulkEmails;
      state.totalPages = payload.totalPages;
      state.currentPage = payload.currentPage;
      state.totalItems = payload.totalItems;
    },
    [getBulkEmails.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // getById
    [getBulkEmailById.pending]: (state) => {
      state.loading = true;
    },
    [getBulkEmailById.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.bulkEmail = payload;
    },
    [getBulkEmailById.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // recipientsCount
    [getRecipientsCount.fulfilled]: (state, { payload }) => {
      state.recipientsCount = payload?.count ?? 0;
    },

    // recipientsList
    [getRecipientsList.fulfilled]: (state, { payload }) => {
      state.recipientsList = payload || [];
    },

    // delete
    [deleteBulkEmail.fulfilled]: (state, { payload }) => {
      state.bulkEmails = state.bulkEmails.filter((e) => e._id !== payload);
    },
    [deleteBulkEmail.rejected]: (state, { payload }) => {
      state.error = payload;
    },
  },
});

export const { clearError, clearBulkEmail, clearRecipients } =
  bulkEmailsSlice.actions;
export default bulkEmailsSlice.reducer;
